<header class="mast-main-head fixed-top">
  <!-- <div class="main-header-offer-section">
    <p><img class="tree-img" src="assets/img/christ-tree.png" alt="">  Seasonal Special: Enjoy a <b>50%</b> Discount on Any Plan. Use coupon code <b>SEASON50</b>  <img class="skate-img" src="assets/img/skate.png" alt=""></p>
  </div> -->

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.
      <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <!-- Navigation -->
    <!-- style="box-shadow: 0px 0px 10px rgba(0,0,0,0.1)" -->
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">

    <div class="container left-header-subscribe">

      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>

      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>

      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li>
                  <a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icons/Navigation/Arrow Down/Black">
                      <g id="Group">
                        <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </g>
                  </svg> -->
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
          <!-- <li class="nav-item login-btn" *ngIf="showGoToApp">
            <a class="nav-link app-btn" (click)="checkWorkspaces()">Go to app</a>
          </li> -->
           <li class="nav-item signup-btn">
             <a class="nav-link button" data-toggle="modal" (click)="listWorkspace()">Start for free</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="toast-section" *ngIf="mobileViewSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 toast-area">
        <span>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</span>
      </div>
    </div>
  </div>
</section>

<section class="hero-section" style="background: none;">
	<div class="container">
		<div class="row">
      <div class="col-sm-6">
				<div class="inner-content">
          <h1>Celebrating Our Happy Subscribers</h1>
					<p>Thank you for being part of the Crafttor family!</p>
					<div class="btn-wrapper">
            <!-- <a class="gray-btn" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a> -->
            <!-- <a class="button" (click)="listWorkspace()">Start for Free</a> -->
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="img-box">
					<img src="assets/img/cheers.svg" alt="cheers illustration">
				</div>
			</div>
		</div>
	</div>
</section>

<section class="comparison-feedbacks happy-things">
  <div class="container">
    <h3>Our Happy Subscribers</h3>
    <div class="row">
      <div class="company-box">
        <img src="assets/img/airtel.svg" alt="Logo">
      </div>
      <div class="company-box">
        <img src="assets/img/wheels.svg" alt="Logo">
      </div>
      <div class="company-box">
        <img src="assets/img/airtel.svg" alt="Logo">
      </div>
      <div class="company-box">
        <img src="assets/img/airtel.svg" alt="Logo">
      </div>
      <div class="company-box">
        <img src="assets/img/airtel.svg" alt="Logo">
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
        <img src="assets/img/logo.svg">
        <p>Digital assets management</p>
        <a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
      </div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a>Workspace</a></li>
        <li><a (click)="openMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features">Features</a></li>
        <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
        <li><a routerLink="/smart-storage">Smart storage</a></li>
        <li><a routerLink="/effective-search">Effective search</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
        <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
        <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
        <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Solutions</h5>
      <ul class="menu">
        <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
        <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
        <li><a routerLink="/box-alternative">Box alternative</a></li>
        <li><a routerLink="/content-library">Content library</a></li>
        <li><a routerLink="/user-profiling">User Profiling</a></li>
        <li><a routerLink="/approvals">Creative approvals</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging">Tagging</a></li>
        <li><a routerLink="/features/sharing">Sharing</a></li>
        <li><a routerLink="/features/versioning">Versioning</a></li>
        <li><a routerLink="/features/collaboration">Collaboration</a></li>
        <li><a routerLink="/features/integration">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
        <li><a routerLink="/about-workspace">About Workspace</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a routerLink="/terms">Terms & Conditions</a></li>
        <li><a routerLink="/faq">FAQ</a></li>
        <li><a routerLink="/feedbacks">Feedback</a></li>
        <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
        <li><a routerLink="/our-mission">Our mission</a></li>
        <li><a routerLink="/partner-with-us">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
    </div>

    <div class="col-sm-12 text-center">
        <small>&copy; 2025 Crafttor. All rights reserved</small>
      </div>
  </div>
  </div>
</footer>
